import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, nameCircles, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		'@media screen and (min-width: 768px)': {
			paddingLeft: 48,
			paddingRight: 48,
		},
		alignItems: 'center',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		fontSize: 14,
		justifyContent: 'center',
		margin: '0 auto',
		padding: '0 12px',
		...CssSelectors.allChildren(
			{
				borderTop: `2px solid ${nameCircles}`,
			},
			':not(:first-child)'
		),
	},
	details: {
		flex: '1 1',
		textAlign: 'left',
		gap: 16,
		display: 'flex',
		flexDirection: 'column',
	},
	detailsAreaWrap: {
		overflow: 'auto',
		width: '100%',
		maxHeight: 440,
		whiteSpace: 'pre-wrap',
	},
	eventPrice: {
		width: '100%',
		fontWeight: 600,
	},
	eventDetailsContainer: {
		'@media only screen and (max-width: 1023px)': {
			display: 'block',
		},
		marginBottom: 24,
		marginTop: 24,
		gap: 24,
		display: 'flex',
		maxWidth: 1024,
		width: '100%',
	},
	eventDetailsTitle: {
		color: brandPrimaryText,
		fontSize: 16,
	},

	previewImage: {},
	previewImageContainer: {
		'@media only screen and (min-width: 768px)': {
			flex: '1',
			minHeight: 300,
			minWidth: 300,
		},
		border: 0,
		margin: '0 auto',
		minHeight: 280,
		overflow: 'hidden',
		padding: 0,
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'img'
		),
	},
	locationAreaWrap: {
		width: '100%',
		maxHeight: 200,
		overflow: 'auto',
	},
});
